import { useMemo } from "react";

// both signatures (keamanan, staff) of a pengecekan are there
const isFullyVerified = (pengecekan) =>
  !!pengecekan &&
  pengecekan.verif_keamanan_id > 0 &&
  pengecekan.verif_staff_id > 0;

const useEditorPermission = ({
  permissions,
  isBerangkat,
  pengecekanBerangkatData,
  pengecekanKembaliData,
}) => {
  const permittedToEdit = useMemo(() => {
    // authorize to permit edit
    let _permittedToEdit = false;
    if (
      permissions &&
      (permissions.includes("view it") ||
        permissions.includes("view kabag-keamanan") ||
        permissions.includes("view keamanan"))
    ) {
      _permittedToEdit = true;
    }

    // everything is locked once both sides are fully verified, and the berangkat page is locked as soon as
    // berangkat is fully verified (the kembali page stays open for the kembali part)
    const berangkatVerified = isFullyVerified(pengecekanBerangkatData);
    if (
      (berangkatVerified && isFullyVerified(pengecekanKembaliData)) ||
      (isBerangkat && berangkatVerified)
    ) {
      _permittedToEdit = false;
    }
    return _permittedToEdit;
  }, [permissions, isBerangkat, pengecekanBerangkatData, pengecekanKembaliData]);

  return { permittedToEdit };
};

export default useEditorPermission;
